import React from 'react';
import { AURAVEX_LOGO } from './logo';
import SignupWizard from './SignupWizard';

const T = {
  bg:"#0A1628",panel:"#0F1E35",hi:"#C48A0E22",gold:"#C48A0E",
  text:"#F5DEB3",muted:"rgba(245,222,179,0.55)",red:"#FF6B6B",
  green:"#00C896",font:"'Segoe UI',system-ui,sans-serif",
  mono:"'Courier New',monospace"
};

const API_NODE = (typeof process !== 'undefined' && process.env && process.env.REACT_APP_API_URL)
  ? process.env.REACT_APP_API_URL : '';

const LoginPage = ({onLogin}) => {
  const [email,      setEmail]      = React.useState("");
  const [password,   setPassword]   = React.useState("");
  const [error,      setError]      = React.useState("");
  const [showPw,     setShowPw]     = React.useState(false);
  const [loading,    setLoading]    = React.useState(false);
  const [showSignup, setShowSignup] = React.useState(false);

  const gold = "#C48A0E";
  const BG   = "linear-gradient(135deg,#0A1628 0%,#112240 50%,#0A1628 100%)";
  const inp  = {width:"100%",padding:"12px 14px",borderRadius:10,
    background:"rgba(255,255,255,0.07)",border:"1px solid rgba(196,138,14,0.3)",
    color:"#fff",fontSize:13,fontFamily:T.font,outline:"none",boxSizing:"border-box"};

  function handleLogin(e) {
    if(e) e.preventDefault();
    setError(""); setLoading(true);
    fetch(API_NODE+"/api/auth/login", {
      method:"POST", headers:{"Content-Type":"application/json"},
      body: JSON.stringify({email:email.trim().toLowerCase(), password})
    }).then(function(res){
      return res.json().then(function(d){ return {ok:res.ok, d:d}; });
    }).then(function(r){
      if(r.ok && r.d.token){
        localStorage.setItem("auravex_token", r.d.token);
        var role = r.d.user && r.d.user.role==="Super Admin" ? "superadmin" :
                   r.d.user && r.d.user.role==="Tenant Admin" ? "government" : "private";
        onLogin(r.d.user && r.d.user.name ? r.d.user.name : email, role, r.d.user);
        setLoading(false); return;
      }
      setError(r.d.error || "Invalid email or password");
      setLoading(false);
    }).catch(function(){
      setError("Cannot connect to server. Check backend is running.");
      setLoading(false);
    });
  }

  function handleSignupComplete(name, role, user) {
    setShowSignup(false);
    var mappedRole = user && user.role==="Super Admin" ? "superadmin" :
                     user && user.role==="Tenant Admin" ? "government" : "private";
    onLogin(name, mappedRole, user);
  }

  function focusGold(e)  { e.target.style.borderColor = gold; }
  function blurGold(e)   { e.target.style.borderColor = "rgba(196,138,14,0.3)"; }

  var pwBtnStyle = {position:"absolute",right:12,top:"50%",transform:"translateY(-50%)",
    background:"none",border:"none",cursor:"pointer",color:"rgba(255,255,255,0.5)",fontSize:14};

  return (
    <div style={{minHeight:"100vh",background:BG,display:"flex",alignItems:"center",
      justifyContent:"center",fontFamily:T.font,position:"relative",overflow:"hidden"}}>

      <div style={{position:"absolute",inset:0,backgroundImage:"radial-gradient(circle,#C48A0E18 1px,transparent 1px)",backgroundSize:"32px 32px",pointerEvents:"none"}}/>
      <div style={{position:"absolute",top:"20%",left:"50%",transform:"translateX(-50%)",width:600,height:300,
        borderRadius:"50%",background:"#C48A0E0A",filter:"blur(60px)",pointerEvents:"none"}}/>

      <div style={{background:"rgba(255,255,255,0.04)",backdropFilter:"blur(20px)",
        border:"1px solid rgba(196,138,14,0.3)",borderRadius:20,padding:"44px 40px",
        width:420,position:"relative",zIndex:1,boxShadow:"0 32px 64px rgba(0,0,0,0.5)"}}>

        <div style={{textAlign:"center",marginBottom:32}}>
          <img src={AURAVEX_LOGO} alt="AURAVEX" style={{width:60,height:60,borderRadius:12,border:"2px solid #C48A0E44",marginBottom:16}}/>
          <div style={{fontSize:22,fontWeight:800,color:"#F5DEB3",letterSpacing:1}}>AURAVEX GLOBAL AI</div>
          <div style={{fontSize:11,color:"#C48A0E",fontWeight:600,marginTop:4,letterSpacing:2,textTransform:"uppercase"}}>Engineering Intelligent Authority</div>
          <div style={{fontSize:10,color:"rgba(255,255,255,0.4)",marginTop:8}}>AI-Powered Multi-Tenant Video Intelligence</div>
        </div>

        <div style={{display:"flex",flexDirection:"column",gap:16}}>
          <div>
            <label style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,0.6)",display:"block",marginBottom:6,letterSpacing:1}}>EMAIL ADDRESS</label>
            <input type="email" value={email} onChange={function(e){setEmail(e.target.value);}}
              placeholder="your@email.com" autoFocus required style={inp}
              onFocus={focusGold} onBlur={blurGold}/>
          </div>
          <div>
            <label style={{fontSize:11,fontWeight:700,color:"rgba(255,255,255,0.6)",display:"block",marginBottom:6,letterSpacing:1}}>PASSWORD</label>
            <div style={{position:"relative"}}>
              <input type={showPw?"text":"password"} value={password} onChange={function(e){setPassword(e.target.value);}}
                placeholder="Enter password" required style={{...inp,paddingRight:40}}
                onFocus={focusGold} onBlur={blurGold}/>
              <button type="button" onClick={function(){setShowPw(function(p){return !p;});}} style={pwBtnStyle}>
                {showPw ? "Hide" : "Show"}
              </button>
            </div>
          </div>
          {error && (
            <div style={{background:"rgba(192,57,43,0.15)",border:"1px solid rgba(192,57,43,0.4)",
              borderRadius:8,padding:"10px 14px",fontSize:12,color:"#FF7675"}}>
              {error}
            </div>
          )}
          <button type="button" disabled={loading} onClick={handleLogin}
            style={{background:loading?"rgba(196,138,14,0.4)":"linear-gradient(135deg,#C48A0E,#9A6B00)",
              border:"none",borderRadius:10,padding:"13px",color:"#000",
              fontSize:13,fontWeight:800,cursor:loading?"not-allowed":"pointer",letterSpacing:1,marginTop:4}}>
            {loading ? "Authenticating..." : "LOGIN TO PLATFORM"}
          </button>
        </div>

        <div style={{display:"flex",alignItems:"center",gap:10,margin:"20px 0"}}>
          <div style={{flex:1,height:1,background:"rgba(255,255,255,0.1)"}}/>
          <span style={{fontSize:11,color:"rgba(255,255,255,0.3)"}}>or</span>
          <div style={{flex:1,height:1,background:"rgba(255,255,255,0.1)"}}/>
        </div>

        <button type="button" onClick={function(){setShowSignup(true);}}
          style={{width:"100%",background:"rgba(196,138,14,0.1)",border:"1px solid rgba(196,138,14,0.4)",
            borderRadius:10,padding:"12px",color:"#C48A0E",fontSize:13,fontWeight:700,cursor:"pointer",
            letterSpacing:.5}}>
          New User Registration
        </button>

        <div style={{textAlign:"center",marginTop:16,fontSize:10,color:"rgba(255,255,255,0.2)"}}>Cloud Platform · Edge Server · V4.2.1</div>
      </div>

      {showSignup && <SignupWizard onClose={function(){setShowSignup(false);}} onSignupComplete={handleSignupComplete}/>}
    </div>
  );
};

export default LoginPage;
